import { render, staticRenderFns } from "./AllContainersList.vue?vue&type=template&id=b80bdf7e"
import script from "./AllContainersList.vue?vue&type=script&lang=js"
export * from "./AllContainersList.vue?vue&type=script&lang=js"
import style0 from "./AllContainersList.vue?vue&type=style&index=0&id=b80bdf7e&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports